import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import LandingPage from './LandingPage';
import PrivacyPolicyPage from './PrivacyPolicyPage';
import ProfileSharePage from './ProfileSharePage';
import ProfileDetailsPage from './ProfileDetailsPage';
import InvitePage from './InvitePage';
import SupportPage from './SupportPage';
import DonatePage from './DonatePage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/donate" element={<DonatePage />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/support" element={<SupportPage />} />
        <Route path="/invite/*" element={<InvitePage />} />
        <Route path="/profile/:profileId" element={<ProfileSharePage />} />
        <Route path="/profile-details" element={<ProfileDetailsPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
